import React from "react";

function L99FeatureComponentCode() {
  return (
    <div>
      {/* L99 Feature variant (l099Feature): larger image + non-italic copy */}
      <div className="lego l099 l099Feature legoMargin5">
        <div className="legoContainer">
          <div className="imgContainer">
            <a target="_blank" rel="noreferrer" href="https://www.ortho.wustl.edu/content/Rehabilitation-for-Long-COVID/8621/Rehabilitation-for-Long-COVID.aspx#tips">
              <img
                className=""
                alt="Rehabilitation Strategies for Long COVID Symptoms"
                src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/pdf/2026/jpgs/Rehabilitation-Strategies-screenshot-web.png"
              />
            </a>
          </div>
          <div className="contentContainer">
            <p className="descriptionHeader">Now available online: Rehabilitation Strategies for Long COVID symptoms</p>
            <p>
              Visit{" "}
              <a className="blueLinkfont22" target="_blank" rel="noreferrer" href="https://www.ortho.wustl.edu/content/Rehabilitation-for-Long-COVID/8621/Rehabilitation-for-Long-COVID.aspx#tips">
                Rehabilitation Strategies for Long COVID
              </a>{" "}
              symptoms for a wide range of useful videos and other information featuring
              past patients and our teams who cover topics including: fatigue, pacing,
              activity management, brain fog, cognitive skills, therapies and next steps.
            </p>
          </div>
        </div>
      </div>
      {/* End L99 Feature variant */}
    </div>
  );
}

export default L99FeatureComponentCode;
